import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Box } from "@vk-hr-tek/ui/Box";
import { Typography } from "@vk-hr-tek/ui/Typography";
import { EmptyStateImage } from "../EmptyStateImage/index.js";
const EmptyContentState = (t0)=>{
    const $ = c(7);
    const { mode: t1, title } = t0;
    const mode = void 0 === t1 ? "list" : t1;
    let t2;
    if ($[0] !== mode) {
        t2 = /*#__PURE__*/ jsx(EmptyStateImage, {
            mode: mode
        });
        $[0] = mode;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== title) {
        t3 = /*#__PURE__*/ jsx(Typography, {
            variant: "body2",
            color: "text.light.secondary",
            children: title
        });
        $[2] = title;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20",
            children: [
                t2,
                t3
            ]
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
export { EmptyContentState };
